export default __webpack_public_path__ + "locales/si/EmptyView.json?hash=26b28f5feab12fc525541f2bfb2a0949";